import { useState, useContext } from "react";

import Modal from "../UI/Modal";
import CartItem from "./CartItem";
import classes from "./Cart.module.css";
import CartContext from "../../store/cart-context";

const Cart = (props) => {
  const cartCtX = useContext(CartContext);

  const totalAmount = cartCtX.totalAmount.toFixed(2);
  const hasItems = cartCtX.items.length > 0;

  const cartItemRemoveHandler = (id) => {
    cartCtX.removeItem(id)
  };
  const cartItemAddHandler = (item) => {
    cartCtX.addItem({...item, amount: 1})
  };

  const cartItems = (
    <ul className={classes["cart-items"]}>
      {cartCtX.items.map((item) => (
        <CartItem
          key={item.id}
          name={item.name}
          amount={item.amount}
          price={item.price}
          onRemove={cartItemRemoveHandler.bind(null, item.id)}
          onAdd={cartItemAddHandler.bind(null, item)}
        />
      ))}
    </ul>
  );

  return (
    <Modal onClose={props.onClose}>
      {cartItems}
      <div className={classes.total}>
        <span>Prix total</span>
        <span>{totalAmount}</span>
      </div>
      <div className={classes.actions}>
        <button className={classes["button--alt"]} onClick={props.onClose}>
          Fermer
        </button>
        {hasItems && <button className={classes.button}>Commander</button>}
      </div>
    </Modal>
  );
};

export default Cart;
